import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useIsPremiumFeatureEnabled } from '@/hooks';
import { COLOR } from '@/theme/colors';

const ReachedOutMaximumTeamCapacity = () => {
    const { t } = useTranslation();
    const { isPremiumFeatureEnabled } = useIsPremiumFeatureEnabled();

    if (isPremiumFeatureEnabled) {
        return (
            <Box className="flex flex-col gap-2 mt-4">
                <Typography fontWeight={700} color={COLOR.errorRed}>
                    {t('Organisations:team_maximum_capacity')}
                </Typography>
                <Typography fontSize={12} fontWeight={400}>
                    {t('Organisations:team_free_up_space_premium_message')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box className="flex flex-col gap-2 mt-4">
            <Typography fontWeight={700} color={COLOR.errorRed}>
                {t('Organisation:invite_via_email:no_seats_left_title')}
            </Typography>
            <Typography fontSize={12} fontWeight={400}>
                {t('Organisation:invite_via_email:no_seats_left_description')}
            </Typography>
        </Box>
    );
};

export default memo(ReachedOutMaximumTeamCapacity);
